import type { ModuleKey } from '@hrms/shared';

/** Display names — deliberately separate from `nav.ts`'s section labels (some, like Attendance,
 * cover exactly one nav section; others, like `custom_workflow`, are named for what they gate
 * rather than what any one menu item is called). */
export const MODULE_LABELS: Record<ModuleKey, string> = {
  core_hr: 'Core HR',
  attendance: 'Attendance',
  statutory_payroll: 'Payroll',
  expense_reimbursement: 'Expenses & Travel',
  shift_rostering: 'Shift Rostering',
  performance_okr: 'Performance & OKRs',
  ats_recruitment: 'Recruitment (ATS)',
  custom_workflow: 'Approval Workflow Authoring',
  multi_entity: 'Multiple Legal Entities',
  leave: 'Leave',
  projects: 'Projects & Timesheets',
  onboarding: 'Onboarding',
  asset_management: 'Asset Management',
  recognition: 'Recognition',
  chat: 'Chat',
  ai_copilot: 'AI Copilot',
  helpdesk: 'Help desk',
  training: 'Training',
  engage: 'Engage (announcements, surveys, celebrations)',
  offboarding: 'Exit & offboarding',
  travel: 'Travel',
  app_integrations: 'Connected applications',
};
